export default [
  {
    path: "/onetoone",
    name: "onetoone",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "onetoone.Baslik",
      yetki: { k: [2002902] },
    },
  },
  {
    path: "/onetoone/form/:uuid",
    name: "onetoone-form",
    component: () => import("./form.vue"),
    meta: {
      public: false,
      title: "onetoone.Baslik",
      yetki: { k: [2002902] },
    },
  },
]
